import { useMemo } from 'react';
import { getCanViewPersonalization } from 'personalization-lib/utils/auth';
const useCanViewPersonalizations = () => useMemo(() => getCanViewPersonalization(), []);
export default useCanViewPersonalizations;